import script from "./ListColumnsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ListColumnsFilter.vue?vue&type=script&setup=true&lang=js"

import "./ListColumnsFilter.vue?vue&type=style&index=0&id=71b8573a&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b8573a"]])

export default __exports__